"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TeachingPopoverSurface", {
    enumerable: true,
    get: function() {
        return TeachingPopoverSurface;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const _reactsharedcontexts = require("@fluentui/react-shared-contexts");
const _useTeachingPopoverSurface = require("./useTeachingPopoverSurface");
const _useTeachingPopoverSurfaceStylesstyles = require("./useTeachingPopoverSurfaceStyles.styles");
const _renderTeachingPopoverSurface = require("./renderTeachingPopoverSurface");
const TeachingPopoverSurface = /*#__PURE__*/ _react.forwardRef((props, ref)=>{
    const state = (0, _useTeachingPopoverSurface.useTeachingPopoverSurface_unstable)(props, ref);
    (0, _useTeachingPopoverSurfaceStylesstyles.useTeachingPopoverSurfaceStyles_unstable)(state);
    (0, _reactsharedcontexts.useCustomStyleHook_unstable)('useTeachingPopoverSurfaceStyles_unstable')(state);
    return (0, _renderTeachingPopoverSurface.renderTeachingPopoverSurface_unstable)(state);
});
TeachingPopoverSurface.displayName = 'TeachingPopoverSurface';
